import HowItWorksCarousel from "./HowItWorksCarousel";

export default HowItWorksCarousel;
